interface SponsorshipLevelsProps {
  onCTAClick: () => void;
}

export default function SponsorshipLevels({ onCTAClick }: SponsorshipLevelsProps) {
  const levels = [
    {
      name: 'Extra Point Sponsor',
      price: '$500',
      color: 'from-purple-600 to-purple-700',
      benefits: [
        'Business name/logo on CYFA website',
        'Social media recognition',
        'Youth Night shoutout',
        'Homecoming float recognition'
      ],
      mockup: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/371930f65d60b8c910aa1165672931cf.png'
    },
    {
      name: 'Field Goal Sponsor',
      price: '$1,000',
      color: 'from-yellow-500 to-yellow-600',
      benefits: [
        'All Extra Point benefits',
        'Logo on Caledonia Youth Football t-shirts'
      ],
      mockup: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/1e5cff518c19121d7d88083866ef657d.png',
      popular: true
    },
    {
      name: 'Touchdown Sponsor',
      price: '$2,000',
      color: 'from-purple-700 to-purple-800',
      benefits: [
        'All Field Goal benefits',
        'Logo on field signage at home games'
      ],
      mockup: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/714eda1c256b7aa6bdda62a3e65f6d4c.png',
      mockup2: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/36674126d40a4a6d50917efffeb070a2.jpeg'
    },
    {
      name: 'Super Bowl Sponsor',
      price: '$3,000',
      color: 'from-yellow-600 to-yellow-700',
      benefits: [
        'All Touchdown benefits',
        'Logo on game day jerseys'
      ],
      mockup: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/e3208f8d4ca5144e9fbb2f2d00f03260.png',
      mockup2: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/902a0881eb6b44d52ed1cd1f98557b1e.png'
    }
  ];

  return (
    <section id="sponsorship-levels" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            Sponsorship <span className="text-purple-700">Levels</span>
          </h2>
          <p className="text-2xl text-gray-700 max-w-3xl mx-auto font-medium">
            Choose the level that's right for your business
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {levels.map((level, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 ${
                level.popular ? 'ring-4 ring-yellow-400' : ''
              }`}
            >
              {level.popular && (
                <div className="bg-yellow-400 text-purple-900 text-center py-2 font-black text-sm uppercase tracking-wider">
                  Most Popular
                </div>
              )}
              
              <div className={`bg-gradient-to-br ${level.color} p-8 text-white`}>
                <h3 className="text-2xl font-black mb-4 leading-tight">{level.name}</h3>
                <div className="text-5xl font-black mb-2">{level.price}</div>
              </div>
              
              <div className="p-8">
                <ul className="space-y-4 mb-8">
                  {level.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-purple-100 rounded-full mt-1">
                        <i className="ri-check-line text-sm text-purple-700"></i>
                      </div>
                      <span className="text-gray-700 font-medium leading-snug">{benefit}</span>
                    </li>
                  ))}
                </ul>
                
                {level.mockup && (
                  <div className="mb-8 w-full flex flex-col gap-3">
                    <div className="w-full h-48">
                      <img
                        src={level.mockup}
                        alt={`${level.name} Mockup`}
                        className="w-full h-full object-cover rounded-lg"
                      />
                    </div>
                    {(level as any).mockup2 && (
                      <div className="w-full h-48">
                        <img
                          src={(level as any).mockup2}
                          alt={`${level.name} Mockup 2`}
                          className="w-full h-full object-cover rounded-lg"
                        />
                      </div>
                    )}
                  </div>
                )}
                
                <button
                  onClick={onCTAClick}
                  className="w-full px-6 py-4 bg-purple-700 hover:bg-purple-800 text-white text-lg font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Sponsor This Level
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}